import React, { useCallback, useRef, useState } from 'react'
import styles from './style.module.css';
import { useSelector } from 'react-redux';
import Button from '../../../design-system/lib/Button';
import { BARCODE, BOX, CLOSE, DeliveryOnly_active, Deliveryonly_deactive, Edit, IC_SEARCH, Ic_danger, LINK_CIRCLE, LOCATION, MORE, PATH, PERSON, PickupOnly_Deactive, RECEIPT, ROUTE_OPTIMIZE, Search_Table, TIMER, box_gray, calendar_time_gray, flag, flag_gray, DONE_CIRCLE, ic_fail, ic_home, trash } from '../../../assets';
import Typography from '../../../design-system/lib/Typography';
import { checkTimestamp, get_calendarType, get_lang, get_timeFormat } from '../../../helper/UserData/userdate';
import jalali from "jalali-moment";
import Tag from '../../../design-system/lib/Tag';
import IconProvider from '../../../design-system/lib/IconProvider';
import Input from '../../../design-system/lib/Input';
import { useParams } from "react-router-dom";
import { Link } from 'react-router-dom';
import history from '../../../service/history';
import { RouteDetailsES } from "@onro/onboarding";
import { LearnMore } from '../../learnMore';
import { useTranslation } from 'react-i18next';
import service_point from '../../../assets/service_point.svg';
import { isEmpty } from 'lodash';
import momentJalaali from "moment-jalaali";
import { lengthFormatter, metersToMiles } from '../../new-order/estimate-path-time';


function ListItems({ stops, route , filteredText , setFilteredText , getOrderData , selectedStop , routeId , selectedStopId , stopsCount , durationSeconds , distanceMeters}) {
  const { t, i18n } = useTranslation();
  const Globalsettings = useSelector((state) => state.SharedData.settings)

  let DeliveryCount = stops.filter((item)=> String(item.address).toLocaleLowerCase().includes(String(filteredText).toLocaleLowerCase())).filter((item) => { return item.stage == "Delivery" })
  let PickupCount = stops.filter((item)=> String(item.address).toLocaleLowerCase().includes(String(filteredText).toLocaleLowerCase())).filter((item) => { return item.stage == "Pickup" })


      const formatDurationAndDistance = React.useCallback((durationSeconds, distanceMeters) => {
    
        let distanceString = '';
        let durationString = '';
    
        // پردازش فاصله
        if (distanceMeters !== undefined && distanceMeters !== null) {
        distanceString = String(lengthFormatter(Globalsettings.lengthUnit == "mile" ? metersToMiles(distanceMeters) : distanceMeters / 1000 , Globalsettings.lengthUnit , Globalsettings.lengthUnitFormat)).replace(/[\u00A0\s]+/g, '')

             // if (distanceMeters < 1000) {
            //     distanceString = `${distanceMeters}m`;
            // } else {
            //   let kilometers = (distanceMeters / 1000).toFixed(1);
            //    distanceString = `${parseInt(kilometers).toLocaleString()}km`;
            // }
        }
    
        // پردازش زمان
        if (durationSeconds !== undefined && durationSeconds !== null) {
            if (durationSeconds < 60) {
                durationString = `${durationSeconds}s`;
            } else if (durationSeconds < 3600) {
                let minutes = Math.floor(durationSeconds / 60);
                durationString = `${minutes}m`;
            } else {
                let hours = Math.floor(durationSeconds / 3600);
                let minutes = Math.floor((durationSeconds % 3600) / 60);
                if (minutes > 0) {
                  durationString = `${hours}h , ${minutes}m`;
              } else {
                  durationString = `${hours}h`;
              }
            }
        }
    
        // ترکیب نتایج
        if (distanceString && durationString) {
            return `${distanceString} | ${durationString}`;
        } else if (distanceString) {
            return distanceString;
        } else if (durationString) {
            return durationString;
        } else {
            return ''; // هیچ مقداری وجود ندارد
        }     }, [Globalsettings]);
   
  

  console.log("ListItems ",routeId)


      const dateIstoday = React.useCallback((datex) => {
         let datexxx = new Date(datex);
        
        let options = { hour: '2-digit', minute: '2-digit' };
        let startTime;

          if (datexxx.toDateString() == new Date().toDateString()) {
              return true
         } 
        // if (date.toDateString() == new Date().toDateString()) {
        //     startTime = `${t("Start time")}: ${t("Today")} ${jalali(route.startDate).locale(get_lang()).format("HH:mm")}`;
        // } else if (date.toDateString()  == new Date(new Date().setDate(new Date().getDate() - 1)).toDateString()) {
        //     startTime = `${t("Start time")}: ${t("Yesterday")} ${jalali(route.startDate).locale(get_lang()).format("HH:mm")}`;
        // } else if (date.toDateString()  == new Date(new Date().setDate(new Date().getDate() + 1)).toDateString()) {
        //     startTime = `${t("Start time")}: ${t("Tomorrow")} ${jalali(route.startDate).locale(get_lang()).format("HH:mm")}`;
        // } else {
        //     startTime = `${t("Start time")}: ${jalali(route.startDate).locale(get_lang()).format("D MMM HH:mm")}`;
        // }
        
        return false
        }, [ ]);

  return (
    <div className={styles.container} >
          <div className={styles.secorow}>
    
      
        {stopsCount > 0 && <Tag backgroundColor='GrayUltraLight' color='TextNormal' iconSize='16' size='Medium' icon={box_gray} text={stopsCount} weight='Body_Small_Medium' style={{ borderRadius: "8px" }} />
        }    
        {(PickupCount?.length > 0) && <Tag backgroundColor='GrayUltraLight' iconSize='16' color='TextNormal' size='Medium' text={`${t("Pickup:")} ${PickupCount.length}`} icon={PickupOnly_Deactive} weight='Body_Small_Medium' style={{ borderRadius: "8px" }} />}
        {(DeliveryCount?.length > 0) && <Tag backgroundColor='GrayUltraLight' iconSize='16' color='TextNormal' size='Medium' text={`${t("Delivery:")} ${DeliveryCount.length}`} icon={Deliveryonly_deactive} weight='Body_Small_Medium' style={{ borderRadius: "8px" }} />}
       {/* <Tag backgroundColor='GrayUltraLight' iconSize='16' color='TextNormal' size='Medium' text={`${Number(distanceMeters / 1000).toFixed(0)} km`} icon={PATH} weight='Body_Small_Medium' style={{ borderRadius: "8px" }} />
        <Tag backgroundColor='GrayUltraLight' iconSize='16' color='TextNormal' size='Medium' text={`${t("Duration:")} ${Number(durationSeconds / 60).toFixed(0)}m`} icon={TIMER} weight='Body_Small_Medium' style={{ borderRadius: "8px" }} />
        */}
        {( distanceMeters ||  durationSeconds) ? <Tag icon={flag_gray} text={formatDurationAndDistance( durationSeconds, distanceMeters)} color='TextNormal' weight='Body_Small_Regular' iconSize='16' backgroundColor='GrayUltraLight' size='Medium' /> : null}

      </div>
      
      <Input type={"text"} iconStart={IC_SEARCH} placeHolder={t('Search stops')} value={filteredText ? String(filteredText).trim() : ""} onChange={(e)=>{setFilteredText(e.target.value && (String(e.target.value).length > 0) ? e.target.value : "" )}} ContainerclassName={styles.input} />

     {/* {String(filteredText).length == 0 && <div className={styles.row}>
        {(DeliveryCount?.length > 0) && <Tag backgroundColor='GrayUltraLight' iconSize='16' color='TextNormal' size='Medium' text={`${t("Delivery:")} ${DeliveryCount.length}`} icon={Deliveryonly_deactive} weight='Body_Small_Medium' style={{ borderRadius: "8px" }} />}
        {(PickupCount?.length > 0) && <Tag backgroundColor='GrayUltraLight' iconSize='16' color='TextNormal' size='Medium' text={`${t("Pickup:")} ${PickupCount.length}`} icon={PickupOnly_Deactive} weight='Body_Small_Medium' style={{ borderRadius: "8px" }} />}
      </div>} */}

      <div className={styles.listItemsContainer}>

      {String(filteredText).length == 0 &&  <div className={`${styles.itemContainer} ${styles.firstEnd}`} style={{ marginTop: "10px", minHeight: "25px" ,border : (String(filteredText).length == 0 &&  stops.length == 0 && (!route.endLocation?.address || String(route.endLocation?.address).trim().length == 0) ) && "0px"} }>
          <IconProvider Icon={ic_home} className={styles.stopIcon} />
          <div className={styles.addressStage}>
            <Typography weight='Body_Small_Medium' text={route.startLocation.address} textColor='TextDark' className={styles.address} />
          </div>
        </div>}


        {String(filteredText).length == 0 && stops.map((stop, i) => {
          return <Link to={`/route/${routeId}/${stop.id}`}  style={{textDecoration :"unset"}} ><div onClick={()=>{getOrderData(stop.id,stop)}} className={`${styles.item} ${stop.id} ${selectedStop?.id} ${selectedStopId == stop.id ? styles.selectedStop : ""}`}> <div className={styles.itemContainer} style={{border : (((i == (stops.length - 1)) && !route.endLocation) || String(filteredText).length == 1) && "0px"}}>
            <span className={stop.stage == "Pickup" ? styles.stopIconP : styles.stopIconD} style={{opacity: ["Successful", "Failed"].indexOf(stop.status) > -1 ? "60%":"100%"}}>{i + 1}</span>
            <div className={styles.addressStage}>
              <Typography weight='Body_Small_Medium'  text={stop.order[String(stop.stage).toLowerCase()]?.locationType == "service-point" ? stop.order[String(stop.stage).toLowerCase()]?.servicePoint?.name : stop.address} textColor='TextDark' className={styles.address}  style={{opacity: ["Successful", "Failed"].indexOf(stop.status) > -1 ? "60%":"100%" , color :"rgba(36, 36, 36, 1)"}} />
    
              <div>
                <Tag backgroundColor='GrayUltraLight' iconSize='16' color='TextNormal' size='Medium' text={stop.stage} icon={stop.stage == "Pickup" ? PickupOnly_Deactive : Deliveryonly_deactive} weight='Body_Small_Regular' style={{ borderRadius: "8px" }} />
               {stop.order[String(stop.stage).toLowerCase()]?.locationType == "service-point" && <Tag backgroundColor='GrayUltraLight' iconSize='16' color='TextNormal' size='Medium' text={t("Service point")} icon={ service_point} weight='Body_Small_Regular' style={{ borderRadius: "8px" ,marginInlineStart:"8px" }} />}
               {!isEmpty(stop.order[String(stop.stage).toLowerCase()]?.fullName) && <Tag backgroundColor='GrayUltraLight' iconSize='16' color='TextNormal' size='Medium' text={stop.order[String(stop.stage).toLowerCase()]?.fullName} icon={ PERSON} weight='Body_Small_Regular' style={{ borderRadius: "8px" ,marginInlineStart:"8px" }} />}
               {( stop.order[String(stop.stage).toLowerCase()]?.completeAfter || stop.order[String(stop.stage).toLowerCase()]?.completeAfter > 0 )&& <Tag backgroundColor='GrayUltraLight' iconSize='16' color='TextNormal' size='Medium' text={`${momentJalaali(stop.order[String(stop.stage).toLowerCase()]?.completeAfter).locale(get_calendarType()).format(checkTimestamp(stop.order[String(stop.stage).toLowerCase()]?.completeAfter))}${momentJalaali(stop.order[String(stop.stage).toLowerCase()]?.completeBefore).locale(get_calendarType()).format(` - ${get_timeFormat()}`)}`} icon={ calendar_time_gray} weight='Body_Small_Regular' style={{ borderRadius: "8px" ,marginInlineStart:"8px" }} />}

              </div>
            </div>
            {/* {["Successful", "Failed"].indexOf(stop.status) > -1 && <IconProvider Icon={stop.status == "Successful" ? ic_done : ic_fail} size='16' style={{ marginInlineEnd: "2px" ,marginInlineStart:"auto" }} />} */}
            { (stop.order[String(stop.stage).toLowerCase()]?.realETA || ["Successful", "Failed"].indexOf(stop.status) > -1) && <Tag backgroundColor='GrayUltraLight' icon={["Successful", "Failed"].indexOf(stop.status) > -1 && (stop.status == "Successful" ? DONE_CIRCLE : ic_fail)} iconSize='16' color='TextNormal' size='Medium' text={["Successful", "Failed"].indexOf(stop.status) > -1 ?   momentJalaali(stop?.statusUpdatedAt).locale(get_calendarType()).format(checkTimestamp(stop?.statusUpdatedAt))
               : momentJalaali(stop.order[String(stop.stage).toLowerCase()]?.realETA).locale(get_calendarType()).format(checkTimestamp(stop.order[String(stop.stage).toLowerCase()]?.realETA))}  weight='Body_Small_Regular' style={{ borderRadius: "8px" }} />}

          </div>
          </div></Link> 
        })}


        {String(filteredText).length > 0 && stops.filter((item)=> String(item.address).toLocaleLowerCase().includes(String(filteredText).toLocaleLowerCase())).map((stop, i) => {
          return <Link to={`/route/${routeId}/${stop.id}`}  style={{textDecoration :"unset"}} ><div onClick={()=>{getOrderData(stop.id,stop)}} className={`${styles.item} ${stop.id} ${selectedStop?.id} ${selectedStop?.id == stop.id ? styles.selectedStop : ""}`}> <div className={styles.itemContainerSearch}>
            <div className={styles.addressStage}>
              <Typography weight='Body_Small_Medium' text={stop.address} textColor='TextDark' className={styles.address} />
              <Tag backgroundColor='GrayUltraLight' iconSize='16' color='TextNormal' size='Medium' text={stop.stage} icon={stop.stage == "Pickup" ? PickupOnly_Deactive : Deliveryonly_deactive} weight='Body_Small_Medium' style={{ borderRadius: "8px" }} />
            </div>
            {["Successful", "Failed"].indexOf(stop.status) > -1 && <IconProvider Icon={stop.status == "Successful" ? DONE_CIRCLE : ic_fail} size='16' style={{ marginInlineEnd: "2px" ,marginInlineStart:"auto" }} />}

          </div>
          </div></Link>
        })}




        {(String(filteredText).length == 0 && route.endLocation) && <div className={`${styles.itemContainer} ${styles.firstEnd}`} style={{ marginTop: "-10px" ,border:"unset" }}>
          <IconProvider Icon={flag} className={styles.stopIcon} style={{outline:"5px solid transparent"}} />
          <div className={styles.addressStage}>
            <Typography weight='Body_Small_Medium' text={route.endLocation.address} textColor='TextDark' className={styles.address} />
          </div>

        </div>}

        { (String(filteredText).length > 0 && stops.filter((item)=> String(item.address).toLocaleLowerCase().includes(String(filteredText).toLocaleLowerCase())).length == 0)   && <NoResulut clearOnclick={()=>{setFilteredText("")}} />}


        {stops.length == 0 && <AddYourOrdersError />}


      </div>

    </div>
  )
}


export default ListItems




function AddYourOrdersError({ reload }) {
    const { t } = useTranslation();

  return (
      <div className='jojojoj'
          style={{ display: 'flex', position: 'relative',  width: "100%", flexDirection: 'column', transition: "all .3s ease-in-out", justifyContent: "center", alignItems: "center" }}>
          <div className={styles.dialog} style={{width:"100%" ,marginTop:"26px"}}>
              {/* <IconProvider Icon={BOX} style={{ marginBottom: "16px" }} />
              <Typography weight='Body_Middle_Bold' text='Add your orders' style={{ textAlign: "center", marginBottom: "4px" }} />
              <Typography weight='Body_Tiny_Regular' text='You can add orders from orders pages' style={{ textAlign: "center", marginBottom: "16px" }} />
              <Button size='Medium' type='Primary' text='Go to Orders' onClick={()=>{history.push("/PickupDelivery")}} /> */}
              <RouteDetailsES articleTitle={"How to add orders to route?"}
  articleLink={"https://help.onro.io/en/articles/10264648-how-to-change-an-order-s-route"}
  emptyStateTitle={t("Add orders")}
  emptyStateDescription={t("Bulk select in orders list and add orders with edit status button")}
  LearnButton={<><LearnMore where='OndemandOrderList'  hastext={true} placement={"topStart"} /></>}
  orderButtonTitle={t("Orders")}
  onOrderLink={()=>{
    history.push("/PickupDelivery")
  }} />
          </div>
      </div>
  )
}


function NoResulut({clearOnclick}) {
  const { t, i18n } = useTranslation();

  return (
      <div className='jojojoj'
          style={{ display: 'flex', position: 'relative', height: `calc(100vh - 104px)`, width: "100%", flexDirection: 'column', transition: "all .3s ease-in-out", justifyContent: "start", alignItems: "center" ,paddingTop:"30px"}}>
          <div className={styles.dialog}>
              <IconProvider Icon={LOCATION} style={{ marginBottom: "16px" }} size='24' />
              <Typography weight='Body_Middle_Bold' text={t('No Stop was found')} style={{ textAlign: "center", marginBottom: "4px" }} />
              <Typography weight='Body_Tiny_Regular' text={t('Please check it again or try another keyword')} style={{ textAlign: "center", marginBottom: "16px" }} />
                <Button size='Medium' type='Primary' text={t('clear')} onClick={clearOnclick} />
          </div>
      </div>
  )
}
